import axios from '@/services/axios.js'
import baseURLs from '@/api/APIBaseURLs'
import { getHeadersWithAccessToken } from '@/auth/tokenService'
import { createOptionsFromColumnsAndData } from '@/api/stockOperateAPI'

export async function getOptionSets (query = '') {
  const url = baseURLs.manageAPI + '/options_sets' + query
  const response = await axios.get(url)
  return response.data
}
export async function getPropertiesAndValues (tableName, format = 'doa') {
  const url = baseURLs.tsqlAPI + '/options_finder'
  const params = { format: format, table_name: tableName || '' }

  const response = await axios.get(url, { headers: getHeadersWithAccessToken(), params })
  // For intelisense
  return {
    properties: response.data.properties,
    values: response.data.values,
    ...response.data,
  }
}

export function saveOptionSettings (data, params) {
  const url = baseURLs.manageAPI + '/option_settings'

  return axios
    .post(
      url,
      data,
      { headers: getHeadersWithAccessToken(), params }
    )
    .then(r => r.data)
    .catch(console.error)
}

export function loadOptionData (params) {
  const url = baseURLs.tsqlAPI + '/options_finder'

  return axios
    .post(url,   {'filters': [['properties/article/option_key', '=', params.option_key]], 'return_properties': true} ).then(response => {
      const data = response.data.data[0]
      const differentPrice = data.asp !== data.osp
      return {
        Price: differentPrice ? `${data.asp} / ${data.osp}` : data.asp.toString(),
        image_url: data.image_url,
        option_name: data.name,
        product_key: data.product_key,
        properties: data.properties,
        variation_key: data.variation_key,
      }
    })
    .catch((error) => console.log(error))
}

export function getStoreProjectionChartData (payload, signal) {
  const url = baseURLs.logicAPI + '/projection'

  return axios
    .post(
      url,
      payload,
      {
        headers: getHeadersWithAccessToken(),
        signal,
      }
    )
    .then(response => response.data)
    .catch((error) => console.log(error))
}

export function getExplain (payload, signal) {
  const url = baseURLs.logicAPI + '/explain'

  return axios
    .post(
      url,
      payload,
      {
        headers: getHeadersWithAccessToken(),
        signal,
      },
    )
    .then(response => response.data)
    .catch((error) => console.log(error))
}

export function searchOptions (searchTerm) {
  const url = baseURLs.manageAPI + '/data/general/options/search'
  const input = '%' + searchTerm + '%'

  return axios.get(url, {
    headers: getHeadersWithAccessToken(),
    params: { 'query': input, 'limit': 100 },
  })
    .then(response => response.data.data)
    .catch((error) => console.log(error))
}

export function findOptionsByFiltersTSQL (filters, columns = [
  'option_key',
  'image_url',
  'name',
  'route',
  'variation_key',
  'osp',
  'asp',
  'stock',
  'dc_stock',
  'inbounds',
  'active',
  'stock_active',
  'planning_active',
  'product_key',
  'skus',
  'stores_included',
  'discount'
]) {
  const url = baseURLs.tsqlAPI + '/options_finder'

  return axios
    .post(url, {
      ...filters,
      format: 'lists',
      columns,
    })
    .then(response => ({
      options: createOptionsFromColumnsAndData(response.data.columns, response.data.data),
      refreshTime: response.data.refresh_time,
    }))
    .catch(error => {
      console.error(error)
      return null
    })
}
export function findProductsByFiltersTSQL (filters) {
  const url = baseURLs.tsqlAPI + '/products_finder'

  return axios
    .post(url, {
      ...filters,
      format: 'lists',
    })
    .then(({data}) => {
      return data.products.data
    })
    .catch(error => {
      console.error(error)
      return null
    })
}

export function getOptionVariations (variationKey) {

  const url = baseURLs.tsqlAPI + '/options_finder'

  return axios
    .post(url,   {'filters': [['properties/article/variation_key', '=', variationKey]]} ).then(response => {
      return response.data.data.map(data=> ({
        Price:  data.asp !== data.osp ? `${data.asp} / ${data.osp}` : data.asp.toString(),
        image_url: data.image_url,
        option_name: data.name,
        option_key: data.option_key,
        stock: data.stock,
        properties: data.properties,
        variation_key: data.variation_key,
      }))
    })
    .catch(error => {
      console.log(error)
    })
}
